import { includes } from 'lodash';

const DROPBOX_GENERIC = 'www.dropbox.com';
const DROPBOX_USER = 'dl.dropboxusercontent.com';

// eslint-disable-next-line no-useless-escape
const EXPRESION = /%[0-9][A-z]/g;
const REGEX = new RegExp(EXPRESION);

/**
 * Adapts a url that can't be fetched to one than can, if needed.
 *
 * @param {string} url - The URL where the GeoJSON is stored.
 * @returns {string} The url with de fetcheable GeoJSON.
 * @throws {Error} If something goes wrong.
 */
const adaptURL = url => {
  let adaptedUrl = url;
  if (includes(url, DROPBOX_GENERIC)) adaptedUrl = url.replace(DROPBOX_GENERIC, DROPBOX_USER);

  if (adaptedUrl.match(REGEX))
    adaptedUrl = adaptedUrl.replace(EXPRESION, match =>
      String.fromCharCode(parseInt(match.substr(1, 2), 16))
    );

  return adaptedUrl;
};

export default adaptURL;
